// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"502":"MyDeals","594":"about"}[chunkId] + "." + {"502":"527f591b","594":"4af0550b"}[chunkId] + ".css";
};